import { render, staticRenderFns } from "./NotifLine.vue?vue&type=template&id=2bb5021c&scoped=true"
import script from "./NotifLine.vue?vue&type=script&lang=js"
export * from "./NotifLine.vue?vue&type=script&lang=js"
import style0 from "./NotifLine.vue?vue&type=style&index=0&id=2bb5021c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5021c",
  null
  
)

export default component.exports